<mat-sidenav-container *ngIf="!isStandalone; else standalone">
    <mat-sidenav
        #sidenav
        role="navigation"
        [mode]="mobileQuery.matches ? 'over' : 'side'"
        [opened]="mobileQuery.matches ? 'false' : 'true'"
        class="mat-elevation-z2">
        <app-main-nav [user]="user" (sidenavClose)="toggleSidenav(sidenav)"></app-main-nav>
    </mat-sidenav>
    <mat-sidenav-content>
        <app-main-header [isAuth]="isAuth" (sidenavToggle)="toggleSidenav(sidenav, true)"></app-main-header>
        <main>
            <app-maintenance *ngIf="isMaintenance && !isAuth"></app-maintenance>
            <router-outlet></router-outlet>
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>
<ng-template #standalone>
    <router-outlet *ngIf="!isMaintenance"></router-outlet>
</ng-template>
<div class="loading" *ngIf="isRouteLoading || isTranslationLoading">
    <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
</div>
